fx.ns("models", class Zoom extends fx.Model {

	constructor()
	{
        super({ x : 0, y : 0, scale : 1, value : 100, animate : false});

        this.maximum = 200;
		this.minimum = 25;

	}


	get canZoomIn(){
		return this.value < this.maximum;
	}

	get canZoomOut(){
		return this.value > this.minimum;
	}

	get realValue(){
		return this.value / 100;
	}

	in(){
		let val = this.value;

		switch (val)
		{
			case 25: 
				val = 100;
				break;
			case 100: 
				val = 125;
				break;
			case 125: 
				val = 150;
				break;
			case 150: 
				val = 175;
				break;
			case 175: 
			case 200: 
				val = 200;
				break;
		}
		
		this.value = val;
	}

	out()
	{
		let val = this.value;

		switch (val)
		{
			case 25: 
			case 100: 
				val = 25;
				break;
			case 125: 
				val = 100;
				break;
			case 150: 
				val = 125;
				break;
			case 175: 
				val = 150;
				break;
			case 200: 
				val = 175;
				break;
		}

		this.value = val;
	}

	globalView(slient)
	{
		if(slient)
			this._value = 25;
		else
			this.value = 25;
	}

	editionView()
	{
		this.value = 100;
	}

	zoomView()
	{
		this.value = 125;
	}

	toggle()
	{
		this.value = (this.value == 100) ? 25 : 100;
	}

});